import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout';
import { AuthModal } from './components/auth';
import { CookieConsent } from './components/legal';
import { useAuth } from './stores/auth.store';
import {
  HomePage,
  GameCatalogPage,
  GamePage,
  ProfilePage,
  LeaderboardsPage,
  NotFoundPage,
  // Legal & Content pages
  PrivacyPage,
  TermsPage,
  CookiesPage,
  AboutPage,
  FAQPage,
  SubscribePage,
} from './pages';

function App() {
  const { user, isAuthenticated, checkAuth, signOut } = useAuth();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  // Check auth state on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const handleLogin = () => {
    setIsAuthModalOpen(true);
  };

  const handleLogout = async () => {
    await signOut();
  };

  const handleAuthModalClose = () => {
    setIsAuthModalOpen(false);
  };

  return (
    <>
      <Layout
        navbarProps={{
          isAuthenticated,
          username: user?.username,
          onLogin: handleLogin,
          onLogout: handleLogout,
        }}
      >
        <Routes>
          {/* Main pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/games" element={<GameCatalogPage />} />
          <Route path="/games/:gameId" element={<GamePage />} />
          <Route path="/leaderboards" element={<LeaderboardsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          
          {/* Legal & Content pages */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>

      {/* Auth Modal */}
      <AuthModal isOpen={isAuthModalOpen} onClose={handleAuthModalClose} />
      
      {/* Cookie Consent Banner */}
      <CookieConsent />
    </>
  );
}

export default App;
